import type { CSSProperties } from 'react';
import { getStrings, type Lang } from '../lib/i18n';

type Vars = CSSProperties & Record<`--${string}`, string | number>;

// Structural data: image + accent edge per pain card (copy comes from locales).
const painMeta = [
  { img: '/images/messy-notes.jpg', edge: 'var(--pop-3)', emoji: '📝' },
  { img: '/images/gym-apps-no-help.jpg', edge: 'var(--pop-2)', emoji: '📱' },
  { img: '/images/confused-about-progress.jpg', edge: 'var(--pop-4)', emoji: '📉' },
  { img: '/images/injuries.jpg', edge: 'var(--pop-5)', emoji: '🩹' },
];

export const Pains = ({ lang = 'en' as Lang }: { lang?: Lang }) => {
  const t = getStrings(lang).pains;

  return (
    <section className="relative py-20 md:py-28">
      <div className="container mx-auto px-5 sm:px-6">
        <div className="text-center mb-14" data-reveal>
          <h2 className="font-heading text-4xl md:text-5xl font-black text-ink tracking-tight">{t.heading}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {t.items.map((pain, index) => {
            const m = painMeta[index];
            return (
              <div key={index} data-reveal style={{ '--i': index } as Vars}>
                <article
                  className="card-chunky is-hoverable group h-full overflow-hidden"
                  style={{ '--edge': m.edge } as Vars}
                >
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={m.img}
                      alt={pain.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6 pt-0">
                    <span
                      className="relative -mt-6 mb-3 chip-icon w-12 h-12 text-2xl ring-4 ring-[color:var(--card)]"
                      style={{ '--chip': m.edge } as Vars}
                      aria-hidden="true"
                    >
                      {m.emoji}
                    </span>
                    <h3 className="font-heading text-xl md:text-[1.35rem] font-black text-ink mb-2 leading-snug">{pain.title}</h3>
                    <p className="text-muted">{pain.description}</p>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
